import React, { useContext } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle, Lock } from 'lucide-react';
import { AuthContext } from '../contexts/AuthContext';


const ErrorPage = ({ code, message }) => {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);

  // Determine home page based on user role
  const getHomePage = () => {
    if (!user) return '/';
    return user.role?.name === 'AREA_COORDINATOR' || user.role?.name === 'LOGISTICS_COORDINATOR'
      ? '/dukas'
      : '/';
  };

  const IconComponent = code === 403 ? Lock : AlertTriangle;

  return (
    <Box
      sx={{
        backgroundColor: '#A8CE97',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        p: 2,
      }}
    >
      <IconComponent size={100} color="white" />
      <Typography variant="h1" sx={{ mt: 2, fontWeight: 700, color: 'white' }}>
        {code}
      </Typography>
      <Typography variant="h5" sx={{ mt: 1, color: '#0E3D30' }}>
        {message}
      </Typography>
      <Button
        variant="contained"
        color="primary"
        sx={{ mt: 3 }}
        onClick={() => navigate(getHomePage())}
      >
        Go Home
      </Button>
    </Box>
  );
};

export default ErrorPage;
